import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InfoModalData } from './info-modal.type';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'app-info-modal',
	templateUrl: './info-modal.component.html',
	styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent {
	htmlContent: SafeHtml | undefined = undefined;
	constructor(
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA)
		public data: InfoModalData,
		private sanitizer: DomSanitizer,
	) {
		if (data.htmlContent) {
			this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(data.htmlContent);
		}
	}

	onConfirmed(isSuccessful: boolean): void {
		this.dialogRef.close({ confirmed: isSuccessful });
	}}
